import Box from '@mui/material/Box';
import { red } from '@mui/material/colors';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { action, computed, makeObservable, observable, runInAction } from 'mobx';
import { inject, observer } from 'mobx-react';
import IconeQuantidade from '../IconeQuantidade';
import PopoverSecretaria from '../PopoverSecretaria';
import ReactComponent from '../ReactComponent';

class PeticoesPendentes extends ReactComponent {
    acabouDeClicarEmFecharPeticaoPendente = false;
    abrirPopoverPeticaoPendente = false;
    anchorEl;

    constructor(props) {
        super(props);

        makeObservable(this, {
            acabouDeClicarEmFecharPeticaoPendente: observable,
            abrirPopoverPeticaoPendente: observable,
            anchorEl: observable,
            registro: computed,
            quantidadePeticoesPendentes: computed,
            handleClickPeticaoPendente: action,
            handleClosePeticaoPendente: action,
            sublinhar: action,
            retirarSublinhar: action,
            abrirDocumento: action
        });
    }

    get registro() {
        return this.observableProps.registro;
    }

    handleClickPeticaoPendente = async (event) => {
        this.salaSessaoStore.carregarPecas(this.registro, this.store.idPautaSelecionada);
        if (!this.acabouDeClicarEmFecharPeticaoPendente) {
            this.abrirPopoverPeticaoPendente = true;
            this.anchorEl = event.currentTarget;
        }
    };

    handleClosePeticaoPendente = () => {
        this.acabouDeClicarEmFecharPeticaoPendente = true;
        setTimeout(() => runInAction(() => (this.acabouDeClicarEmFecharPeticaoPendente = false)), 1);
        this.abrirPopoverPeticaoPendente = false;
        this.anchorEl = null;
    };

    sublinhar = (documento) => {
        documento.sublinhado = 'underline';
    };

    retirarSublinhar = () => {
        this.registro.pecas.forEach((peca) => {
            peca.sublinhado = '';
        });
    };

    async abrirDocumento(documento) {
        let mimeType = documento.tipoArquivo === 'PDF' ? 'application/pdf' : 'text/html';
        let conteudo = await this.processoService.recuperarConteudoDocumento(
            this.registro.sessaoId || this.store.idPautaSelecionada,
            this.registro.processo.numeroCompleto,
            documento.tipoArquivo,
            documento.id
        );
        let link = document.createElement('a');
        document.body.appendChild(link);
        link.download = documento.tipoDocumento + (documento.tipoArquivo === 'PDF' ? '.pdf' : '.html');
        link.href = URL.createObjectURL(new Blob([conteudo], { type: mimeType }));
        link.click();
        document.body.removeChild(link);
    }

    get quantidadePeticoesPendentes() {
        return this.registro.informacoesAdicionais?.QuantidadePeticoesPendentes || 0;
    }

    render() {
        return (
            <>
                {this.quantidadePeticoesPendentes > 0 && (
                    <Tooltip
                        title={
                            this.quantidadePeticoesPendentes +
                            (this.quantidadePeticoesPendentes < 2 ? ' petição pendente' : ' petições pendentes')
                        }
                    >
                        <Box
                            sx={{ display: 'flex', m: 0.5, cursor: 'pointer' }}
                            onClick={this.handleClickPeticaoPendente}
                        >
                            <IconeQuantidade quantidade={this.quantidadePeticoesPendentes} />
                        </Box>
                    </Tooltip>
                )}
                {this.registro.pecas && this.abrirPopoverPeticaoPendente && (
                    <PopoverSecretaria
                        open={this.abrirPopoverPeticaoPendente}
                        onClose={this.handleClosePeticaoPendente}
                        anchorEl={this.anchorEl}
                    >
                        <Typography
                            variant="h6"
                            color="primary"
                            sx={{ m: 0.5 }}
                        >
                            Petições Pendentes
                        </Typography>
                        <Box sx={{ m: 0.5 }}>
                            {this.registro.pecas.map((documento) => {
                                if (documento.peticaoPendente) {
                                    return (
                                        <Box key={`peticao_${documento.id}`}>
                                            <Typography
                                                variant="subtitle2"
                                                color="secondary"
                                                onClick={() => this.abrirDocumento(documento)}
                                                style={{
                                                    cursor: 'pointer',
                                                    color: red[900],
                                                    textDecoration: documento.sublinhado
                                                }}
                                                onMouseEnter={() => this.sublinhar(documento)}
                                                onMouseLeave={this.retirarSublinhar}
                                                title={'Abrir documento'}
                                            >
                                                {this.descricaoPeca(documento)}
                                            </Typography>
                                            {documento.statusPeticao && (
                                                <Typography
                                                    sx={{
                                                        fontSize: '12px',
                                                        margin: '0px 10px 10px 10px',
                                                        color: '#01579b',
                                                        fontWeight: 'bold'
                                                    }}
                                                >
                                                    {documento.statusPeticao
                                                        ? `Petição pendente: ${documento.statusPeticao}`
                                                        : 'Petição pendente'}
                                                </Typography>
                                            )}
                                        </Box>
                                    );
                                }

                                return null;
                            })}
                        </Box>
                    </PopoverSecretaria>
                )}
            </>
        );
    }
}

export default inject('stores')(observer(PeticoesPendentes));
